<template>
  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Дэд Хичээл</h1>
        <div class="w-5">
          <button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm" data-original-title=""
                @click="openModal(false)" title="">
                <i class="fa fa-plus pt-1 display-5"> Дэд хичээл нэмэх </i>
              </button>
        </div>
      </div>
      <table class="table" v-if="sublessonlist">
        <thead>
          <tr>
            <th>Гарчиг</th>
            <th class="text-right">Үйлдлүүд</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sublesson_info in sublessonlist" :key="sublesson_info.id">
            <td class="text-center" style="display: flex; flex-direction: column">
              <h6 class="display-5 mb-0" style="text-align: left">
                {{ sublesson_info.sub_lesson.title }}
              </h6>
              <!-- <span class="description" style="text-align: left">{{
                sublesson_info.sub_lesson.info
              }}</span> -->
            </td>

            <td class="td-actions text-right">
              <button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm" data-original-title="" title=""
                @click="downloadPdf(sublesson_info)">
                <i class="fa fa-file-pdf-o pt-1"></i>
              </button>
              <button type="button" rel="tooltip" class="btn btn-success btn-icon btn-sm" data-original-title=""
                title="" @click="openVideoModal(sublesson_info)">
                <i class="fa fa-play pt-1"></i>
              </button>
              <button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm" data-original-title="" title=""
                @click="openModal(true, sublesson_info)">
                <i class="fa fa-pencil pt-1"></i>
              </button>
              <button type="button" rel="tooltip" class="btn btn-danger btn-icon btn-sm" style="margin-left: 30px"
                @click="deleteLesson(sublesson_info)" data-original-title="" title="">
                <i class="fa fa-trash-o pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- Видео тоглуулагч модал -->
    <VimeoPlayerModal 
      :isVideoModalOpen="isVideoModalOpen" 
      @input="isVideoModalOpen = $event"
      :playerEmbedUrl="getEmbedUrl(currentVideoUrl)" 
      :title="currentVideoTitle" 
    />

    <!-- Дэд хичээлийн засварлах/нэмэх модал -->
    <SubLessonEdit 
      :modelValue="isModalOpen" 
      :editMode="isEditMode" 
      :editData="currentEditData"
      :title="isEditMode ? 'Хичээлийг засах' : 'Хичээл нэмэх'" 
      @submit="handleModalSubmit" 
      @input="isModalOpen = $event" 
    />
  </card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import SubLessonEdit from "./../components/lesson/SubLessonEdit.vue";
import VimeoPlayerModal from "./../components/lesson/SublessonVideo.vue";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const TEST_VIDEO_URL =
  "https://player.vimeo.com/video/1033700555?h=bc04b730ce&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479";

const TEST_DATA = [
  // {
  //   firstname: "test",
  //   sub_lesson: {
  //     id: 1,
  //     title: "Тест Хичээл 1",
  //     info: "Тест мэдээлэл",
  //     created_at: "2024-11-27T03:28:39.512409",
  //     created_by: 1,
  //     generated_name: "test.pdf",
  //     given_name: "test.pdf",
  //     pdf_path: "static/pdfs/test.pdf",
  //     updated_at: "2024-11-27T03:28:39.512411",
  //     video_embed_url: TEST_VIDEO_URL,
  //     video_url: "https://vimeo.com/test",
  //   },
  // },
];

export default {
  name: "SubLessons",
  data() {
    return {
      sublessonlist: [],
      isModalOpen: false,
      isVideoModalOpen: false,
      isEditMode: false,
      currentEditData: null,
      currentVideoUrl: "",
      currentVideoTitle: "",
      showDeleteConfirm: false,
      deleteIndex: -1,
    };
  },
  components: {
    SubLessonEdit,
    VimeoPlayerModal,
  },
  methods: {
    openModal(editMode, editData = null) {
      
      const data_lesson = editData ? editData.sub_lesson : null;
      this.isEditMode = editMode;
      this.currentEditData = editMode ? data_lesson : null;
      this.isModalOpen = true;
    },

    async fetchSubLessons() {
      try {
        const response = await axios.get("/sub_lessons");
        this.sublessonlist = response.data;
      } catch (error) {
        console.error("Дэд хичээлийг татаж чадсангүй:", error);
        this.sublessonlist = TEST_DATA;
      }
    },

    async handleModalSubmit() {
      try {
        await this.fetchSubLessons();
        this.isModalOpen = false;
      } catch (error) {
        console.error("Хичээлийг шинэчлэхэд алдаа гарлаа:", error);
      }
    },

    getEmbedUrl(videoUrl) {
      if (videoUrl && videoUrl.includes("player.vimeo.com")) {
        return videoUrl;
      }
      return `https://player.vimeo.com/video/${videoUrl}`;
    },

    openVideoModal(lesson) {
      this.isVideoModalOpen = false;
      this.currentVideoUrl = "";
      const data_lesson = lesson.sub_lesson;
      setTimeout(() => {
        this.currentVideoUrl = data_lesson.video_embed_url;
        this.currentVideoTitle = data_lesson.title;
        this.isVideoModalOpen = true;
      }, 0);
    },

    downloadPdf(lesson) {
      const data_lesson = lesson.sub_lesson;

      axios
        .get(`/sub_lesson/file/${data_lesson.id}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download =
            data_lesson.generated_name || `lesson-${data_lesson.id}.pdf`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("PDF татахад алдаа гарлаа:", error);
        });
    },

    async deleteLesson(lesson) {
      if (confirm("Та энэ хичээлийг устгахдаа итгэлтэй байна уу?")) {
        try {
          await axios.delete(`/sub_lessons/${lesson.sub_lesson.id}`);
          this.fetchSubLessons();
          this.$alert.showAlert("Хичээл амжилттай устгагдлаа","success");
        } catch (error) {
          console.error("Хичээлийг устгахад алдаа гарлаа:", error);
          this.$alert.showAlert("Хичээлийг устгахад алдаа гарлаа","error");
        }
      }
    },

    closeModal() {
      this.isEditMode = false;
      this.currentEditData =  null;
      this.isModalOpen = false;
    },
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
  },
  created() {
    this.fetchSubLessons();
  },
};
</script>